import { useClientsStore } from '@/store/clients';
import { useUsersStore } from '@/store/users';
import { useProductsStore } from '@/store/products'
import { useOpportunitiesStore } from '@/store/opportunities';

export const quotationsOptions = {
    searchClientsAndLeads: async (query = '') => {
    const store = useClientsStore();
    await store.searchClientsAndLeads({ 'filter[name]': query });
    return store.clients_leads;
  },
  searchUsers: async (query = '') => {
    const store = useUsersStore();
    await store.searchUsers({ 'filter[name]': query });
    return store.users_result;
  },
  searchProducts: async (query = '') => {
    const store = useProductsStore();
    await store.fetchProducts({ 'filter[description]': query });
    return store.products;
  },
  searchOpportunity: async (params = {}) => {
    const store = useOpportunitiesStore();
    await store.fetchOpportunities(params);
    return store.opportunities;
  }
};
